module.exports = __webpack_public_path__ + "img/teacher.2ee72684.gif";